/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Explore_Use_Cases_DetailInputs */

const en_common_header_explore_use_cases_detail = /** @type {(inputs: Common_Header_Explore_Use_Cases_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find by what you need`)
};

const zh_common_header_explore_use_cases_detail = /** @type {(inputs: Common_Header_Explore_Use_Cases_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按需求查找`)
};

/**
* | output |
* | --- |
* | "Find by what you need" |
*
* @param {Common_Header_Explore_Use_Cases_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_explore_use_cases_detail = /** @type {((inputs?: Common_Header_Explore_Use_Cases_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Explore_Use_Cases_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_explore_use_cases_detail(inputs)
	return zh_common_header_explore_use_cases_detail(inputs)
});
export { common_header_explore_use_cases_detail as "common.header.explore.use_cases.detail" }